module.exports = __webpack_public_path__ + "static/media/freedom.40796d3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/resource/freedom.svg
// module id = 219
// module chunks = 0